import { SuperAdminConstants } from '../../../_constants';

const initialState = { addAssessmentOrganisationLoading: true, data: '', error: false };

export function addAssessmentOrganisationReducer(state = initialState, action) {

    switch (action.type) {
        case SuperAdminConstants.REQUEST_ADD_ASSESSMENT_ORGANISATION:
            return {
                addAssessmentOrganisationLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ADD_ASSESSMENT_ORGANISATION:
            return {
                addAssessmentOrganisationLoading: false,
                data: action.addAssessmentOrganisation,
                error: false
            };
        case SuperAdminConstants.ADD_ASSESSMENT_ORGANISATION_ERROR:
            return {
                addAssessmentOrganisationLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AddOrganisation/addAssessmentOrganisation.reducer.js